export const SET_RESTAURANT_ID = "set-restaurantId";
export const SET_RESTAURANTS = "set-restaurants";
export const SET_EDIT_RESTAURANTS = "set-edit-restaurants";
